module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-16.bf817948.jpg";